module.exports = __webpack_public_path__ + "static/media/bm.e0a5a6bf.svg";